module.exports = __webpack_public_path__ + "img/login.2d10d51e.png";